import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';

const MODULE_LABELS = {
  booking: { name: 'Terminbuchung', desc: 'Termine, Kurse und Wartelisten verwalten.' },
  crm: { name: 'CRM / Leads', desc: 'Interessenten und Verkaufschancen pflegen.' },
  invoicing: { name: 'Rechnungen & Abrechnung', desc: 'Rechnungen, Zahlungen und Abrechnungen.' },
  ai: { name: 'KI-Assistent', desc: 'KI-gestützte Funktionen und Automatisierung.' },
  nutrition: { name: 'Ernährung', desc: 'Ernährungspläne und Nährwert-Verwaltung.' },
  payroll: { name: 'Lohn & Personal', desc: 'Mitarbeiter, Stundenerfassung und Löhne.' },
};

const ModuleNotBooked = ({ module }) => {
  const navigate = useNavigate();
  const info = MODULE_LABELS[module] || { name: 'Dieses Modul', desc: 'Diese Funktion ist Teil eines Zusatzmoduls.' };

  return (
    <div
      className="min-h-[70vh] flex items-center justify-center px-6"
      data-testid="module-not-booked"
    >
      <Card className="max-w-lg w-full border-slate-200 shadow-sm">
        <CardContent className="p-10 text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-teal-50 text-teal-600">
            <Lock className="h-8 w-8" strokeWidth={1.75} />
          </div>
          <p className="text-sm font-medium uppercase tracking-wide text-teal-600" data-testid="module-not-booked-badge">
            Modul nicht gebucht
          </p>
          <h1 className="mt-2 text-2xl font-semibold text-slate-900" data-testid="module-not-booked-title">
            {info.name}
          </h1>
          <p className="mt-3 text-slate-500 leading-relaxed">
            {info.desc} Dieses Modul gehört nicht zu Ihrem aktuellen Abo. Schalten Sie es frei, um es zu nutzen.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button
              onClick={() => navigate('/admin/subscription')}
              className="bg-teal-600 hover:bg-teal-700 text-white gap-2"
              data-testid="module-not-booked-upgrade-btn"
            >
              <Sparkles className="h-4 w-4" />
              Jetzt freischalten
              <ArrowRight className="h-4 w-4" />
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="text-slate-500"
              data-testid="module-not-booked-back-btn"
            >
              Zurück zum Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ModuleNotBooked;
